export default __webpack_public_path__ + "static/oberon-travelbase-ds-3-806d1351f62efa0635b349c3fa28bd84.jpg";